/* eslint-disable complexity */
import format from 'date-fns/format'

import { toISO861, toISODate } from '@/utils/date'

const getDateOrNull = value =>
  !value ? null : value instanceof Date ? format(value, 'yyyy-MM-dd') : value

const getISODateOrNull = value => (value ? toISODate(new Date(value)) : null)

const getISO861OrNull = value => (value ? toISO861(value) : null)

const parseNumberOrNull = dischargeForecastInDays => {
  const value = parseInt(dischargeForecastInDays)
  return isNaN(value) ? null : value
}

class HospitalizationMapper {
  static toModel(data) {
    return {
      ...data,
      hospitalizationProcedures: data.hospitalizationProcedures ?? [],
      evolutions: data.evolutions ?? [],
      objectiveCodes: data.objectiveCodes ?? [],
      startedAt: getISODateOrNull(data.startedAt),
      endedAt: getISODateOrNull(data.endedAt),
      daysInIntensiveCare: data.daysInIntensiveCare || []
    }
  }

  static toAPI(model) {
    return {
      ...model,
      dischargeSummaryEvaluation: model.dischargeSummaryEvaluation,
      dischargeForecastInDays: parseNumberOrNull(model.dischargeForecastInDays),
      providerUnitId: model.provider?.id ?? null,
      hospitalizationOrigin: model.hospitalizationOrigin ?? null,
      hospitalizationResponsible: model.hospitalizationResponsible ?? null,
      internalPhysician: model.internalPhysician ?? null,
      objectiveCodes: model.objectiveCodes ?? [],
      objectiveCodesReason: model.objectiveCodesReason ?? null,
      flowErrorReason: model.flowErrorReason ?? null,
      procedureDescription: model.procedureDescription ?? null,
      hospitalizationPostProgramming:
        model.hospitalizationPostProgramming ?? null,
      hospitalizationSpecialty: model.hospitalizationSpecialty ?? null,
      coordinated: model.coordinated ?? null,
      startedAt: getISO861OrNull(model.startedAt),
      endedAt: getISO861OrNull(model.endedAt),
      type: 'TIT_HOSPITALIZATION',
      summaryReferenceId: model.summaryReferenceId,
      summaryReferenceModel: model.summaryReferenceModel,
      hospitalizationProcedures:
        model.hospitalizationProcedures
          ?.filter(({ procedureDate, procedure }) => procedureDate && procedure)
          .map(({ procedureDate, procedure }) => ({
            procedureDate,
            procedureId: procedure?.id,
            procedureCode: procedure?.aliceCode
          })) || [],
      newEvolutions:
        model.evolutions?.filter(
          ({ createdAt, staffName, description }) =>
            !createdAt && !staffName && description
        ) || [],
      daysInIntensiveCare:
        model.daysInIntensiveCare
          ?.map(date => getDateOrNull(date))
          .filter(value => value !== null) || [],
      hospitalizationReleaseType: model.hospitalizationReleaseType,
      counterReferrals: model.counterReferrals,
      totvsGuias: model.totvsGuias
    }
  }
}

export { HospitalizationMapper }
